import {ColorSchemeName} from 'react-native';

// import {Appearance} from 'react-native';

// export const colorScheme = Appearance.getColorScheme();
// TODO: Use this when we have support for light color scheme
export type ColorScheme = Exclude<ColorSchemeName, null | undefined>;

export const colorScheme = 'dark';
